// ReactJs
import React, { useContext, useEffect, useState } from 'react'
// Node modules
import styled from 'styled-components'
// Services
// Contexts
import { AppContext } from '../../../Context'
// Utils
import { isArchived, isCreated, isSent, isValidated } from '../../../../common/Record'
// Layouts
import WelcomePageOtherRecords from './WelcomePageOtherRecords'
import WelcomePageValidatedRecords from './WelcomePageValidatedRecords'
import WelcomePageNotifications from '../WelcomePageNotifications'
import { getNotifications } from '../../../services'

const WelcomePageRecordsContainer = styled.div`
`

export default function WelcomePageRecords() {

  const {
    babysittingModes, records, isChildActive
  } = useContext(AppContext)

  const [validatedRecords, setValidatedRecords] = useState(null)
  const [otherRecords, setOtherRecords] = useState(null)
  const [notifications, setNotifications] = useState([])

  useEffect(() => {
    if (records && records.length > 0 && !validatedRecords) {
      setValidatedRecords(records.filter(record => isValidated(record)))
    }
  }, [records, validatedRecords])

  useEffect(() => {
    if (records && records.length > 0 && !otherRecords) {
      setOtherRecords(records.filter(record => isCreated(record) || isArchived(record) || isSent(record)))
    }
  }, [records, otherRecords])

  useEffect(() => {
    const fetch = async () => {
      const result = await getNotifications()
      const allNotifications = result.data.getNotifications
      setNotifications(allNotifications)
    }
    fetch()
  }, [])

  return (
    (records && records.length > 0 && babysittingModes) &&
    <WelcomePageRecordsContainer>

      { notifications && notifications.length > 0 &&
      <WelcomePageNotifications notifications={ notifications } babysittingModes={ babysittingModes }/>
      }

      { validatedRecords && validatedRecords.length > 0 &&
      <WelcomePageValidatedRecords records={ validatedRecords } babysittingModes={ babysittingModes } isChildActive={ isChildActive }/>
      }

      { otherRecords && otherRecords.length > 0 &&
      <WelcomePageOtherRecords records={ otherRecords } babysittingModes={ babysittingModes } isChildActive={ isChildActive }/>
      }

    </WelcomePageRecordsContainer>
  )
}
